import * as $ from 'jquery';
import * as d3 from 'd3';

import { FormatHelper } from './helpers/format';

const BAR_FILL_OPACITY = 0.8;
const YAXIS_GRID_STROKE = '#e5e5e5';

export function getSortedData(settings) {
	if (settings.isHorizontalBar) {
		return _.orderBy(_.cloneDeep(settings.data), d => {
			if (settings.sortField === 'y') { return d.y; }
			if (settings.sortField === 'x') { return d.x; }
			return d.key;
		}, settings.sortType);
	}
	return _.orderBy(_.cloneDeep(settings.data), d => {
		if (settings.sortField === 'y') {
			const value = d.values.reduce((prevValue, currValue) => prevValue + currValue.y, 0);
			return value;
		}
		if (settings.sortField === 'x') {
			const value = d.values.reduce((prevValue, currValue) => prevValue + currValue.x, 0);
			return value;
		}
		return d.key;
	}, settings.sortType);
}

export function MultiColumn(options){
	var settings = $.extend({ // Merge options to default settings.
			$el: d3.select("body"),
			title: "",
			data: [],
			margin: {top: 20, right: 80, bottom: 30, left: 50},
			padding: {top: 0, right: 0, bottom: 0, left: 0},
			width: 960,
			height: 500,
			showMaxMin: false,
			showBlackTooltip: false,
			format: d3.format(',.0f'),
			chart: null,
			show_stack: true,
			stacked: false,
			color: d3.scaleOrdinal(d3.schemeCategory10), // d3.scale.category20(),
			yearRange: undefined,
			tip: null,
			isLock: false,
			lockedTarget: null,
			reserved_value: 0.1,
			isCountryProfile: false,
			isHorizontalBar: false,
			sortField: 'y',
			sortType: 'asc',
			onClick: null,
			onHover: null,
	  }, options);

  var self = this;
  _(settings).each(function(v, k){
    self[k] = v;
  });

	this.render();
}

MultiColumn.prototype.render = function() {
	var self = this;
	if (this.isHorizontalBar) {
		const barLabelWidth = 100;
		var width = this.width - this.margin.left - this.margin.right - barLabelWidth;
		var height = this.height - this.margin.bottom;
		var maxBarHt = 0.10 * height;
		var maxChartHt = maxBarHt * this.data.length;
		height = height > maxChartHt ? maxChartHt : height;
		const sortedData = this.data;
		// Fix first element is rendered in the bottom which isn't same as original unescap
		const data = sortedData.reverse();

		this.min_value = _.min(data, function (o) { return o.value; });
		this.max_value = _.max(data, function (o) { return o.value; });
		var hasNegative = this.min_value.value < 0 ? true : false;
		if (hasNegative) {
			this.x = d3.scaleLinear()
				.range([0, width])
				.domain(d3.extent(data, function (d) { return d.value; }))
		} else {
			this.x = d3.scaleLinear()
				.range([0, width])
				.domain([0, d3.max(data, function (d) {
					return d.value;
				})]);
		}

		this.y =  d3.scaleBand()
			.padding(0.1)
			.rangeRound([height, 0], .1)
			.domain(data.map(function (d) {
				return d.name;
			}));

		//make y axis to show bar names
		this.yAxis = d3.axisLeft()
			.scale(this.y)
			.tickSize(0); //no tick marks

		this.$el.select('svg').remove();
		this.svg = this.$el.append("svg")
			.attr("width", this.width)
			.attr("height", this.height);

		this.gWrapper = this.svg.append('g')
			.attr('class', 'wrapper');

		this.gWrapperInner = this.gWrapper.append('g')
			.attr('class', 'wrapper-inner');

		this.rectOverlay = this.gWrapperInner.append("rect")
			.attr("class", "overlay")
			.attr("width", width)
			.attr("height", height)
			.style('fill', 'transparent');

		this.gWrapperInner
			.append('g')
				.attr('class', 'y axis').attr("transform", "translate(" + self.x(0) + ",0)")
				.call(this.yAxis)
				.selectAll(".tick text")
					.text(function (d) {
						return '';
					});

		let labelWidth = 0;
		this.gWrapperInner
			.selectAll('.tick')
			.select('text')
				.attr('class', 'horizontal_label')
				.each(function () {
					labelWidth = Math.ceil(Math.max(labelWidth, this.getBBox().width));
				});

		this.containerBars = this.gWrapperInner.selectAll('.bar').data(data)
			.enter()
				.append('g')
				.attr('class', 'container-bar')
				.attr('data-name', (d) => d.key);

		//append rects
		this.rect = this.containerBars
			.append('rect')
				.attr('class', 'bar')
				.attr('y', function (d) {
					return self.y(d.name);
				})
				.attr('height', this.y.bandwidth()) // .attr('height', this.y.rangeBand())
				.attr('x', function (d) {
					var tempX = self.x(Math.min(0, d.value));
					if (!hasNegative) return tempX + 1;
					return tempX;
				})
				.attr('width', function (d) { return Math.abs(self.x(d.value) - self.x(0)); })
				.attr("data-name", function(d) {
					return d.key;
				})
				.attr("data-year", function(d) {
					return d.x;
				})
				.attr("data-value", function(d) {
					return d.y;
				})
				.style('fill', function (d) {
					return self.color(d.name);
				})
				.style('fill-opacity', BAR_FILL_OPACITY);

		// add a value label to the right of each bar
		this.barText = this.containerBars.append('text').attr('class', 'label')
			// y position of the label is halfway down the bar
			.attr('y', function (d) {
				return self.y(d.name) + self.y.bandwidth() / 2 + 4; // self.y(d.name) + self.y.rangeBand() / 2 + 4;
			})
			.attr("x", function (d) {
				var width = this.getBBox().width;
				if (d.value < 0) return Math.abs(self.x(0));
				return Math.max(width, Math.abs(self.x(d.value)));// - self.x(0)));
			})
			.attr("dx", 10) //margin right
			.text(function (d) {
				return FormatHelper.formatEscapNumber(self.min_value.value, self.max_value.value, d.value);
			})
			.style('font-size', '50%');

		this.gWrapper
			.attr('transform', 'translate(' + (labelWidth + this.margin.left) + ',' + this.margin.top + ')');

		this.gWrapper.append('text').attr('class', 'y-axis-label')
			.attr('x', (this.width) * 0.90)
			.attr('y', 15)
			.attr('dy', '.71em')
			// .text(this.yAxisLabel)
			.call(this.wrapHeight, this.height);
	} else if (this.stacked) {
		var margin = this.margin;
		var reserved_value = this.reserved_value;
		var min_year = self.yearRange[0];
		var max_year = self.yearRange[1];

		const sortedData = this.data;
		// Fix first element is rendered in the bottom which isn't same as original unescap
		sortedData.reverse();
		const data = [];
		// const data2 = [];
		const flattenData = [];
		const allYears = [];
		const stackedKeys = [];
		for (const dataGroup of sortedData) {
			stackedKeys.push(dataGroup.key);
			for (const dataValue of dataGroup.values) {
				flattenData.push({ ...dataValue, key: dataGroup.key, });
				allYears.push(dataValue.x);
				// data2.push({
				// 	x: dataValue.x,
				// 	y: dataValue.y,
				// 	yKey: dataGroup.key,
				// });
			}
		}
		const years = d3.union(allYears);
		for (const year of years) {
			const datum = { x: year };
			for (const stackedKey of stackedKeys) {
				const _datum = flattenData.find(e => {
					return e.key === stackedKey && e.x === year;
				});
				if (_datum) {
					datum[stackedKey] = _datum.y;
				} else {
					// console.log(stackedKey, year);
					datum[stackedKey] = 0;
				}
			}
			data.push(datum);
		}

		var stack = d3.stack().keys(stackedKeys);
		var stackedData = stack(data);
		// console.log(data, data2, stackedData);

		var width = self.width - margin.left - margin.right - self.padding.left - self.padding.right,
			height = self.height - margin.top - margin.bottom - self.padding.top - self.padding.bottom;

		var xDomain = [];
		for(var i = min_year; i <= max_year; i++){
			xDomain.push(i);
		}

		const flattenValues = [];
		for (const stackedGroup of stackedData) {
			for (const stackedItem of stackedGroup) {
				flattenValues.push(stackedItem[1]);
			}
		}
		self.min_value = Math.min(...flattenValues);
		self.max_value = Math.max(...flattenValues);
		if(self.min_value > 0 && self.max_value > 0){
			self.min_value = 0;
		}else if(self.min_value < 0 && self.max_value < 0){
			self.max_value = 0;
		}
		if (self.min_value === self.max_value) {
			self.max_value++;
		}

		this.x = d3.scaleBand()
			.domain(xDomain)
			.range([0, width])
			.padding(0.1);
		this.y = d3.scaleLinear()
			.domain([self.min_value, self.max_value]).range([height, 0]);

		this.xAxis =  d3.axisBottom()
			.scale(this.x)
			.tickPadding(7)
			.tickSizeInner(0)
			.tickSizeOuter(0);

		if(xDomain.length > 12){
			this.xAxis.tickValues(this.x.domain().filter(function(d, i) { return !(d % 5); }))
		}else if(xDomain.length > 8){
			this.xAxis.tickValues(this.x.domain().filter(function(d, i) { return !(d % 3); }))
		}else if(xDomain.length > 5){
			this.xAxis.tickValues(this.x.domain().filter(function(d, i) { return !(d % 2); }))
		}

		this.yAxis = d3.axisLeft()
			.scale(this.y)
			.tickFormat(function(d) {
				return FormatHelper.formatEscapNumber(self.min_value, self.max_value, d); })
			.tickSizeInner(-width)
			.tickSizeOuter(0);
		if (this.isCountryProfile) {
			this.yAxis.ticks(5);
		}

		this.$el.select('svg').remove();
		this.svg = this.$el.append("svg").attr("width", this.width).attr("height", this.height);

		// Wrapper for the margins
		this.gWrapper = this.svg.append("g").attr('class', 'wrapper')
			.attr("transform", "translate(" + margin.left + "," + margin.top + ")");

		// Wrapper inner for padding of x and y axises
		this.gWrapperInner = this.gWrapper.append('g').attr('class', 'wrapper-inner')
			.attr('transform', 'translate(' + self.padding.left + ', ' + self.padding.bottom + ')');

		this.gWrapperInner.append("g").attr("class", "x axis")
			.attr("transform", "translate(0," + height + ")")
			.call(this.xAxis);

		this.gWrapperInner
			.append("g")
				.attr("class", "y axis")
				.call(this.yAxis)
				.selectAll('line')
					.style('stroke', YAXIS_GRID_STROKE);

		this.rectOverlay = this.gWrapperInner.append("rect")
			.attr('class', 'overlay')
			.attr("width", width)
			.attr("height", height)
			.style('fill', 'transparent');

		var columnG = this.gWrapperInner.selectAll('.column-g')
			.data(stackedData)
			.enter().append('g')
				.attr('class', 'column-g')
				.attr('data-name', function(d) {
					return d.key; });

		this.rect = columnG.selectAll('.rect')
			.data(function(d) {
				return d; /* d.values; */ })
			.enter()
			.append('rect')
				.attr('width', this.x.bandwidth())
				.attr('class', 'rect')
				.attr('x', function(d) {
					return self.x(d.data.x); })
				.attr('y', function(d) {
					// if(d.y0 > 0)
					// 	return self.y(d.y + d.y0);
					// else if(d.y0 + d.y < 0)
					// 	return self.y(0);
					// else
					// 	return self.y(d.y + 0);
					// if (d.y0 + d.y < 0)
					// 	return self.y(0);
					// else
					// 	return self.y(d.y); // self.y(d.y + d.y0);
					return self.y(d[1]); })
				.attr('height', function(d) {
					return self.y(d[0]) - self.y(d[1]); })
				.attr('data-name', function(d) {
					d.name = d3.select(this.parentNode).attr('data-name');
					return d.name; })
				.attr('data-year', function(d) {
					return d.data.x; })
				.attr('data-value', function(d) {
					return d.data[d.name]; })
				.style('fill', function(d) {
					return self.color(d.name); })
				.style('fill-opacity', BAR_FILL_OPACITY);

		this.svg.append('text')
			.attr('class', 'y-axis-label')
			.attr('transform', 'rotate(-90)')
			.attr('x', (this.height / 2) * -1)
			.attr('y', 0)
			.attr('dy', '.71em')
			.text(this.title)
			.call(this.wrapHeight, this.height);
	} else {
		var sortedData = this.data;
		var margin = this.margin;
		var reserved_value = this.reserved_value;
		var hiddenHeight = 5;

		var min_year = self.yearRange[0];
		var max_year = self.yearRange[1];
		const values = sortedData.map(d => d.values.map(d2 => d2.y)).flat();
		this.min_value = Math.min(...values);
		this.max_value = Math.max(...values);
		if(self.min_value > 0 && self.max_value > 0){
			self.min_value = 0;
		}else if(self.min_value < 0 && self.max_value < 0){
			self.max_value = 0;
		}

		if (self.min_value === self.max_value) {
			self.max_value++;
		}

		var width = self.width - margin.left - margin.right - self.padding.left - self.padding.right,
			height = self.height - margin.top - margin.bottom - self.padding.top - self.padding.bottom;

		var x0domain = []
		for(var i = min_year; i <= max_year; i++){
			x0domain.push(i);
		}

		this.x0 = d3.scaleBand()
			.domain(x0domain)
			.rangeRound([0, width])
			.padding(0.1);

		this.x1 = d3.scaleBand();

		this.y = d3.scaleLinear()
			.domain([self.min_value, self.max_value])
			.range([height, 0]);

		this.xAxis = d3.axisBottom()
			.scale(this.x0)
			.tickPadding(7)
			.tickSizeInner(0)
			.tickSizeOuter(0);

		if(x0domain.length > 12){
			this.xAxis.tickValues(this.x0.domain().filter(function(d, i) { return !(d % 5); }))
		}else if(x0domain.length > 8){
			this.xAxis.tickValues(this.x0.domain().filter(function(d, i) { return !(d % 3); }))
		}else if(x0domain.length > 5){
			this.xAxis.tickValues(this.x0.domain().filter(function(d, i) { return !(d % 2); }))
		}

		this.yAxis = d3.axisLeft()
			.scale(this.y)
			.tickFormat(function(d) {
				return FormatHelper.formatEscapNumber(self.min_value, self.max_value, d);
			})
			.tickSizeInner(-width)
			.tickSizeOuter(0);
		if (this.isCountryProfile) {
			this.yAxis.ticks(5);
		}

		this.$el.select('svg').remove();
		this.svg = this.$el.append("svg")
			.attr("width", this.width)
			.attr("height", this.height);

		// Wrapper for the margins
		this.gWrapper = this.svg.append("g")
			.attr('class', 'wrapper')
			.attr("transform", "translate(" + margin.left + "," + margin.top + ")");

		// Wrapper inner for padding of x and y axises
		this.gWrapperInner = this.gWrapper.append('g')
			.attr('class', 'wrapper-inner')
			.attr('transform', 'translate(' + self.padding.left + ', ' + self.padding.bottom + ')');

		this.gWrapperInner.append("g")
			.attr("class", "x axis")
			.attr("transform", "translate(0," + height + ")")
			.call(this.xAxis);

		this.gWrapperInner.append("g")
			.attr("class", "y axis")
			.call(this.yAxis)
			.selectAll('line')
				.style('stroke', YAXIS_GRID_STROKE);

		this.x1.domain(sortedData.map(function(d){ return d.key; }))
			.rangeRound([0, this.x0.bandwidth()]);
		this.rectOverlay = this.gWrapperInner.append("rect")
			.attr("class", "overlay")
			.attr("width", width)
			.attr("height", height)
			.style('fill', 'transparent');

		var columnG = this.gWrapperInner.selectAll(".column-g")
			.data(sortedData)
			.enter().append("g")
				.attr("class", "column-g")
				.attr("data-name", function(d){ return d.key })
				.attr("transform", function(d) {
					return "translate("+self.x1(d.key)+",0)";
				});

	  this.rect = columnG.selectAll("rect")
			.data(function(d) { return d.values; })
			.enter().append("rect")
				.attr("width", this.x1.bandwidth())
				.attr("class", "rect")
				.attr("x", function(d) { return self.x0(d.x); })
				.attr("y", function(d) {
					if (d.y==reserved_value|| d.y == 0) {
						return self.y(0) - hiddenHeight;
					}
					return (d.y >= 0) ? self.y(d.y): self.y(0);
				})
				.attr("height", function(d) {
					if (d.y==reserved_value|| d.y == 0) {
						return hiddenHeight;
					}
					return Math.abs(self.y(0) - self.y(d.y));
				})
				.attr("data-name", function(d){
					d.name = d3.select(this.parentNode).attr('data-name');
					return d.name;
				})
				.attr("data-value", function(d) {
					return d.y;
				})
				.attr("data-year", function(d){ return d.x; })
				.style("fill", function(d) {
					return self.color(d3.select(this.parentNode).attr('data-name'));
				})
				.style("fill-opacity", function(d){
					if (d.y==reserved_value|| d.y == 0) {
						return 0;
					}
					return BAR_FILL_OPACITY;
				});

		this.svg.append("text")
			.attr('class', 'y-axis-label')
			.attr("transform", "rotate(-90)")
			.attr("x", (self.height/2) * -1)
			.attr('y', 0)
			.attr("dy", ".71em")
			.text(this.title);
	}

	if (self.tip) {
		if (self.tip.context) {
			self.tip
				.context(this.gWrapper)
				.callbackTemplate(function(d) {
					const rectEl = d.currentTarget;
					return `<strong>${rectEl.getAttribute('data-name')}</strong> ${rectEl.getAttribute('data-year')}`
						+ `<center>${FormatHelper.formatEscapNumber(self.min_value, self.max_value, Number(rectEl.getAttribute('data-value')))}</center>`;
				})
				.init();
		}

		self.rectOverlay
			// .on("mousemove", function(e) {
			// })
			.on("click",function(d) {
				if(!self.isLock) {
					self.isLock=true;
					return;
				}
				self.isLock=false;
				self.tip.hide(d);
				if (self.lockedTarget!=null) {
					self.lockedTarget.style('fill-opacity','');
						// $('#yearText').html('&nbsp;');
						// 			$('#legend-chart .list-group-item .value-div').css("display", "none");
						var event = new Event('mouseover');
						var d3This = d3.select(this);
						d3This[0][0].dispatchEvent(event);
				}
			})
			.on("mouseout",function() { });

		self.rect
			.on("mouseover", function(d) {
				if (self.isLock) return;
				const thisEl = d3.select(this);
				if (d.y != reserved_value && d.y != 0) {
					thisEl.style('fill-opacity',1);
				}
				if (self.onHover) self.onHover(thisEl.datum());
				if (self.tip.context) {
					self.tip.show(d, this);
					return;
				}
				const rectEl = d.currentTarget;
				const contentHtml = `<strong>${rectEl.getAttribute('data-name')}</strong> ${rectEl.getAttribute('data-year')}`
					+ `<center>${FormatHelper.formatEscapNumber(self.min_value, self.max_value, Number(rectEl.getAttribute('data-value')))}</center>`;
				self.tip.show(d, contentHtml);
			})
			.on("click", function(d) {
				if (!self.isLock) {
					const thisSelection = d3.select(this);
					self.lockedTarget = thisSelection;
					self.isLock = true;
					if (self.onClick) self.onClick(thisSelection.datum());
					return;
				}
				self.isLock=false;
				if(d.y!=reserved_value && d.y != 0 && self.lockedTarget!=null)
					self.lockedTarget.style('fill-opacity','');
				self.tip.hide(d);
			})
			.on("mouseout", function(d) {
				// if (!self.isLock) {
				if (self.isLock) return;
				if (d.y != reserved_value && d.y != 0) {
					d3.select(this).style('fill-opacity', '0.8');
				}
				self.tip.hide(d);
			});
	}
}
MultiColumn.prototype.redraw = function(data, yearRange) {
  var self = this;
  var colors = this.color;
	var keyColor = function(d, i) {return colors(d.key)};
	self.yearRange = yearRange;
  if(self.chart){
  	if (data) {
  		self.$el.select('svg').select('.y-axis-label').text(self.title);
  	}
  	var yearArr = [];
    for(var i = self.yearRange[0]; i <= self.yearRange[1]; i++){
    	yearArr.push(i);
    }
    self.chart.xDomain(yearArr);
  	self.chart.stacked(self.stacked);
  	self.chart.color(keyColor);
    var svg = self.$el.select("svg").datum(data).transition().duration(0).call(self.chart);
    svg.selectAll('.nv-group')
        .attr('data-name', function(d) {
          return d.key;
        });
    svg.select('.nv-x.nv-axis').selectAll('.tick').select('line').style('opacity',0)
    nv.utils.windowResize(self.chart.update);
  }
  else{
  	self.data = data;
  	this.render();
  }
}

MultiColumn.prototype.wrapHeight = function(text, width){
  text.each(function() {
    var text = d3.select(this),
        words = text.text().split(/\s+/).reverse(),
        word,
        line = [],
        lineNumber = 0,
        lineHeight = 1.1, // ems
        x = text.attr("x"),
        y = text.attr("y"),
        dy = parseFloat(text.attr("dy")),
        tspan = text.text(null).append("tspan").attr("x", x).attr("y", y).attr("dy", dy + "em");
    while (word = words.pop()) {
      line.push(word);
      tspan.text(line.join(" "));
      if (tspan.node().getComputedTextLength() > width) {
        line.pop();
        tspan.text(line.join(" "));
        line = [word];
        tspan = text.append("tspan").attr("x", x).attr("y", y).attr("dy", ++lineNumber * lineHeight + dy + "em").text(word);
      }
    }
  });
}
